var render = function () {
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: (_class = {
      'activity-instructions-container': true
    }, _class[_vm.instructions.class] = !!_vm.instructions.class, _class)
  }, [_c('audio-toggle-button', {
    attrs: {
      "onInstructionsVoiced": _vm.onInstructionsVoiced
    }
  }), _c('h1', {
    staticClass: "activity-instructions"
  }, [_vm._v("\n    " + _vm._s(_vm.instructions.written) + "\n  ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }